/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { changeProduct } from '@xanadu/ui-shared/modules/application/actions';
import { toggleNavigation } from '@xanadu/ui-shared/modules/navigation/actions';

import { EMPTY_LIST } from '../../../constants';

import MobileNavigation from '../../../components/navigation/MobileNavigation';

const EMPTY_ARRAY = [];

const mapDispatchToProps = {
  toggleNavigation,
  changeProduct,
};

function mapStateToProps(state) {
  return {
    tags: state.getIn(['navigation', 'tags'], EMPTY_ARRAY),
    processedTags: state.getIn(['navigation', 'processedTags'], EMPTY_ARRAY),
    topFive: state.getIn(['navigation', 'topFive'], EMPTY_ARRAY),
    navigationVisible: state.getIn(['navigation', 'navigationVisible']),
    topPosition: state.getIn(['navigation', 'topPosition']),
    bannerMessageVisible: state.getIn(['application', 'bannerMessageVisible']),
    product: state.getIn(['application', 'product']),
    widthSize: state.getIn(['application', 'widthSize']),
    countryCode: state.getIn(['user', 'countryCode']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    casinoVisibilityRestricted: state.getIn(['vegas', 'visibilityRestricted']),
    virtualsAllowed: state.getIn(['user', 'virtualsAllowed']),
    inPlayTags: state.getIn(['navigation', 'inPlayTags'], EMPTY_LIST),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileNavigation));
